import React from 'react';
import { Box, Button, darken, IconButton, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

import VideoApp from './VideoApp';

const ContentBox = styled(Box)(({ theme }) => ({
  height: 'calc(100% - 88px)',
  overflowY: 'scroll',
  overflowX: 'hidden',
  padding: `0 ${theme.spacing(2)}`,
  minHeight: '60px',
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
}));

const RobotCallModal = ({ open, items, onCancel }) => {
  return (
    <Modal open={open} sx={{ bgcolor: 'background.paper' }}>
      <Box>
        <Box display="flex" justifyContent="end" sx={{ mb: 2 }}>
          <IconButton aria-label="close" size="large" onClick={onCancel}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>
        <ContentBox>
          <VideoApp {...items} />
        </ContentBox>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            margin: '32px auto 16px',
            gap: '8px',
          }}
        >
          <Button color="secondary" variant="contained" onClick={onCancel}>
            닫기
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RobotCallModal;
